import { ReactComponent as IconDataExchange } from '@/assets/svgs/data-element-icon.svg';
import Button from '@/componentsDS/Button/Button'
import { ButtonType , ButtonVariant} from '@/componentsDS/Button/Button.type';
// [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR.
// import Breadcrumbs from '@/componentsDS/Breadcrumbs/index';
import Breadcrumb from '@/dsComponents/Breadcrumb';
import FilterMenu from '@/pages/onboarding/components/FilterMenu';
import Icon from '@/componentsDS/Icon/Icon';
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import MultiLayerTable from "@/componentsDS/MultiLayerTable/index";
import MultipleEmailAddressInput from '../MultipleEmailAddressInput/index';
import Search from '@/componentsDS/Search/index';
import useModal from '@/hooks/use-modal';
import usePage from "@/hooks/use-page/index";
import PropTypes from "prop-types";
import { useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Toast from '@/components/Toast';
import useToast from '@/hooks/use-toast';
import api from '@/services/api/serviceProviderRelation';
import { useQuery } from "@/lib/router-dom";
import { categorizeFilters, extractUniqueValuesUsingMap, generateQueryString, searchRecords, statusIdMapper, updateFilterByParams } from '@/pages/onboarding/helpers/index';
import { useSearchParams } from 'react-router-dom';
import InputDropdown from '@/dsComponents/InputDropdownSelect/index';
import AddRelationBtn from '../AddRelationBtn/index';
import { Box, DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@dextech-ai/dex-design-system';

const RenderFilterTrigger = () => {
	return (
		<span>
			<Icon name="adjustments-horizontal" style="solid" size="medium" /> <span>Filter</span>
		</span>
	)
}

const RenderGroupByTrigger = ({ groupByDropdownOptions }) => {
	return (
		<span>
			<Icon name="list-view" style="solid" size="medium" /> <span>Group By: {groupByDropdownOptions[0]?.label}</span>
		</span>
	)
}

export const createBody = (orgId, serviceProviderOrgId, flow, dataElementId) => {
	return {
		"dataOwnerOrgId": orgId,
		"serviceProviderOrgId": serviceProviderOrgId,
		"dataElementId": dataElementId,
		"initiater": "DATA_OWNER",
		"flow": flow
	};
};

export const createEmailBody = (orgId, email, flow, dataElementId) => {
	return {
		"dataOwnerOrgId": orgId,
		"invitedViaEmail": email,
		"dataElementId": dataElementId,
		"initiater": "DATA_OWNER",
		"flow": flow
	};
};

export const handleData = (dataElementArr, orgIdArr, flow, orgId, orgEmailList, orgEmail) => {
	const serviceProvidersLists = [];
	if (dataElementArr.length && orgIdArr.length) {
		dataElementArr.forEach((deArr) => {
			orgIdArr.forEach(spOrgId => {
				if (spOrgId.id === 'inviteNewUser') {
					if(orgEmail){
						serviceProvidersLists.push(createEmailBody(orgId, orgEmail, flow, deArr.id));
					}
					orgEmailList.forEach(email => {
						serviceProvidersLists.push(createEmailBody(orgId, email, flow, deArr.id));
					});
				}
				else {
					serviceProvidersLists.push(createBody(orgId, spOrgId.id, flow, deArr.id));
				}
			});
		});
	}
	return serviceProvidersLists;
};

const ServiceProviderTablePage = ({
	title,
	description,
	data,
	headers,
	emptyMessage,
	refreshData,
	setRefreshData,
	customGroupHeaderRender,
	serviceProvidersItems,
	dataElementContributeItems,
	dataElementConsumeItems,
	serviceProviderLoading,
	dataElementLoading,
	orgDataLoading,
}) => {

	// Get Profile
	const profile = useSelector(state => state.auth.profile);
	const orgId = profile?.organizationId;

	const  [serviceProviderData, setServiceProviderData] =useState([])

	useEffect(() => {
		if (serviceProvidersItems.length) {
			setServiceProviderData([{ id: 'inviteNewUser', label: 'Invite New User', value: 'inviteNewUser' }, ...serviceProvidersItems])
		}
	}, [serviceProvidersItems])

	const { breadcrumbsItems } = usePage({
		title: title,
		breadcrumbs:[{
			label: '',
			link: `/`,
		},
		{
			label: title,
			link: ``
		}]
	});

	// Toast Message
	const toastType = {
		success: "success",
		error: "error"
	}
	const { toastList, addToastMessage } = useToast()
	const [loading, setLoading] = useState(false);

	// input dropdown search handler
	const [dropdownSearch, setDropdownSearch] = useState({
		serviceProviders: '',
		dataElementContribute: '',
		dataElementConsume: ''
	})

	const handleDropdownSearch = (e) => {
		if (e?.target) {
			const { name, value } = e.target;
			console.log(name, value)
			setDropdownSearch((prev) => ({ ...prev, [name]: value }));
		}
	};

	/*=================================================
		Modal
	/================================================*/
	const { visible: initiateAddRelationshipModal, show: showInitiateAddRelationshipModal, hide: hideInitiateAddRelationshipModal } = useModal()

	// Email List
	const [orgEmailList, setOrgEmailList] = useState([]);
	const [orgEmail,setOrgEmail]= useState("")
	const [isOrgEmailValid, setIsOrgEmailValid] = useState(false)

	// Multi Select Filter Dropdown Items
	const [selectOrgIds, setSelectOrgIds] = useState([]);
	const [sendDataElement, setSendDataElement] = useState([]);
	const [consumeDataElement, setConsumeDataElement] = useState([]);

	// Query Params
	const [, setSearchParam] = useSearchParams()
	const query = useQuery();
	const [serviceProviderOrgName, dataElementQueryParams, statusQueryParams] = ['from', 'dataElement', 'status'].map(item => query.get(item))

	const [filterDropdownOptions, setFilterDropdownOptions] = useState([]);

	useEffect(() => {
		if (!data) return;
		let updatedFilters = [];

		if (statusQueryParams) {
			statusQueryParams.split(',').forEach(status => {
				updatedFilters.push({
					id: statusIdMapper[status.toUpperCase()],
					label: status.toUpperCase(),
					category: "Status"
				});
			})
		}
		if (serviceProviderOrgName) {
			const serviceProviderResult = updateFilterByParams(data, serviceProviderOrgName, 'serviceProviderOrgId', 'serviceProviderOrgName', 'Solution Provider')
			if (serviceProviderResult.length) {
				updatedFilters = [...updatedFilters, ...serviceProviderResult]
			}
		}
		if (dataElementQueryParams) {
			const dataElementResult = updateFilterByParams(data, dataElementQueryParams, 'dataElementId', 'dataElementName', 'Data Element Name')
			if (dataElementResult.length) {
				updatedFilters = [...updatedFilters, ...dataElementResult]
			}
		}

		if (updatedFilters.length > 0) {
			setFilterDropdownOptions(prevFilters => [...prevFilters, ...updatedFilters]);
		}
		return () => {
			setFilterDropdownOptions([])
		}
	}, [serviceProviderOrgName, statusQueryParams, dataElementQueryParams, data]);

	// HANDLER FUNCTIONS
	const resetData = () => {
		setSelectOrgIds([])
		setSendDataElement([])
		setConsumeDataElement([])
		setOrgEmailList([])
	}

	const openModal = () => {
		resetData()
		showInitiateAddRelationshipModal()
	}

	const handleSubmit = async () => {
		setLoading(true);
		const serviceProvidersLists = [];

		if (sendDataElement.length) {
			handleData(sendDataElement, selectOrgIds, 'SEND', orgId, orgEmailList, orgEmail).forEach(item => serviceProvidersLists.push(item));
		}

		if (consumeDataElement.length) {
			handleData(consumeDataElement, selectOrgIds, 'RECEIVE', orgId, orgEmailList, orgEmail).forEach(item => serviceProvidersLists.push(item));
		}

		const payload = {
			'serviceProviders': serviceProvidersLists,
		}

		const [error] = await api.addServiceProviderRelationship(payload);
		setLoading(false)
		if (error) {
			return addToastMessage(error.message ?? "Failed to add Solution Provider Relationship.", toastType.error)
		}

		hideInitiateAddRelationshipModal();
		addToastMessage("Solution provider relationship requests sent!", toastType.success)
		return setRefreshData(!refreshData);
	}

	/*=================================================
		Search
	/================================================*/
	const [searchValueForServiceProvider, setSearchValueForServiceProvider] = useState('');

	/*=================================================
		Filter
	/================================================*/
	const categoryLabelMap = {
		dataElementName: 'Data Element Name',
		serviceProviderOrgName: 'Solution Provider',
		status: 'Status'
	};

	const LABEL_ID_MAP = [
		{ labelKey: 'dataElementName', idKey: 'dataElementId' },
		{ labelKey: 'serviceProviderOrgName', idKey: 'serviceProviderOrgId' },
		{ labelKey: 'status', idKey: 'status' }
	]
	const finalFilterOptions = LABEL_ID_MAP.flatMap(item => extractUniqueValuesUsingMap(data, item.labelKey, item.idKey, orgId, categoryLabelMap)).map(item => item.category === "Status" ? ({ ...item, id: statusIdMapper[item.id] }) : item)

	/*=================================================
		Search and Filter Logic
	/================================================*/

	// Filter dropdown handler function
	const handleFilterDropdown = (selectedItem) => {
		setFilterDropdownOptions(() => [...selectedItem])
		const filterArrSchema = {
			from: ["Solution Provider"],
			dataElement: ["Data Element Name"],
			status: ["Status"]
		}

		const filterArr = categorizeFilters(selectedItem, filterArrSchema)
		const query = generateQueryString(filterArr)
		setSearchParam(query)
	}

	// to filter data based on search and filter dropdown
	const filteredData = useMemo(() => {
		let filtered = data;

		if (filterDropdownOptions.length > 0) {
			filtered = data.filter((item) => {
				const categoryMatch = {};

				filterDropdownOptions.forEach((filter) => {
					if (filter.category === 'Data Element Name') {
						categoryMatch['Data Element Name'] = categoryMatch['Data Element Name'] || filter.label === item.dataElementName;
					}
					if (filter.category === 'Solution Provider') {
						categoryMatch['Solution Provider'] = categoryMatch['Solution Provider'] || item.serviceProviderOrgName ? filter.label === item.serviceProviderOrgName : filter.label === item.serviceProviderEmail;
					}
					if (filter.category === 'Status') {
						categoryMatch['Status'] = categoryMatch['Status'] || filter.id === (item.statusCode);
					}
				});

				const allCategoriesMatch = Object.values(categoryMatch).every(Boolean);
				return allCategoriesMatch;
			});
		}

		if (searchValueForServiceProvider) {
			const fieldsToSearch = ['dataElementName', 'serviceProviderOrgName'];
			filtered = filtered.filter(item => searchRecords(item, fieldsToSearch, searchValueForServiceProvider));
		}

		return filtered;
	}, [data, filterDropdownOptions, searchValueForServiceProvider]);

	/*=================================================
		Group By
	/================================================*/
	const groupByOptions = [
		{ id: 'dataElementName', label: 'Data Element' },
		{ id: 'serviceProviderOrgName', label: 'Solution Provider' },
		{ id: 'serviceProviderRelationshipStatus', label: 'Status' }
	];

	const [groupByDropdownOptions, setGroupByDropdownOptions] = useState([{ id: 'serviceProviderOrgName', label: 'Solution Provider' }]);

	return (
		<>
			{/* [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR. */}
			{/* <Breadcrumbs breadcrumbItems={breadcrumbsItems} /> */}
			<Breadcrumb items={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{title}</div>
				</div>
			</div>

			<div className="title-header--sub-header">{description}</div>

			<Box display="flex" align="center">
				<div className="title-header__actionable__left">
					<Search value={searchValueForServiceProvider || ''} onChange={(e) => setSearchValueForServiceProvider(e?.target?.value ?? e)} onCancel={() => setSearchValueForServiceProvider('')} id="my-service-provider-search" />

					<FilterMenu
						options={finalFilterOptions}
						value={filterDropdownOptions}
						onChange={handleFilterDropdown}
						trigger={<RenderFilterTrigger />}
						isLoading={serviceProviderLoading}
						id="my-service-provider-filter-dropdown"
					/>

					<DropdownMenu placement="bottomLeft">
						<DropdownMenuTrigger asChild>
							<div className="DS__dropdown-wrapper">
								<Button
									type={ButtonType.UTILITY}
									variant={ButtonVariant.UTILITY}
									dataTestId="my-service-provider-group-by-dropdown"
									text={<RenderGroupByTrigger groupByDropdownOptions={groupByDropdownOptions} />}
								/>
							</div>
						</DropdownMenuTrigger>
						<DropdownMenuContent>
							<DropdownMenuRadioGroup
								value={groupByDropdownOptions[0]?.id}
								onValueChange={(value) => setGroupByDropdownOptions(groupByOptions.filter((option) => option.id === value))}
							>
								{groupByOptions.map((option) => (
									<DropdownMenuRadioItem key={option.id} itemKey={option.id} value={option.id}>
										<span id="my-service-provider-group-by-dropdown">{option.label}</span>
									</DropdownMenuRadioItem>
								))}
							</DropdownMenuRadioGroup>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>

				<div className="title-header__actionable__right">
					<div className="data-exchange-actions-header">
						<div className="data-exchange-actions-header__left">
						</div>
						<div className="data-exchange-actions-header__right">
							<Button
								variant={ButtonVariant.STANDARD}
								type={ButtonType.SOLID}
								data-testid="add-relationship-button"
								text={"+ Add Solution Provider"}
								onClick={() => {
									openModal();
								}}
								id="my-service-provider-add-solution-provider-button"
							/>
						</div>
					</div>
				</div>
			</Box>

			<MultiLayerTable
				data={filteredData}
				headers={headers}
				groupBy={groupByDropdownOptions[0]?.id}
				rowSize="large"
				emptyMessage={emptyMessage}
				customGroupHeaderRender={customGroupHeaderRender}
				loading={serviceProviderLoading}
				sortBy="modified"
				id="my-service-provider-column-sort-"
			/>

			<Modal visible={initiateAddRelationshipModal} close={hideInitiateAddRelationshipModal} dismissClickOutsideModal={false}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='card-configure__title__left__icon'>
											<IconDataExchange />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											<div className='card-configure__title__right__top__title'>
												Add Solution Provider
											</div>
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="card-configure__body__dropdown">
								<span className="card-configure__body__dropdown__title">
									Solution Provider
								</span>
								<InputDropdown
									value={dropdownSearch.serviceProviders}
									onChange={handleDropdownSearch}
									name={"serviceProviders"}
									dropdownOption={serviceProviderData}
									placeholder={"Select Organization(s)"}
									onSelectDropdownItem={setSelectOrgIds}
									multipleSelection
									dropdownSelectedOption={selectOrgIds}
									fullWidth
									isLoading={orgDataLoading}
								/>
							</div>
							{/* If user has selected 'To invite new user' in To dropdown */}
							{selectOrgIds?.find(item => item.value === 'inviteNewUser') &&
								<MultipleEmailAddressInput
									emailList={orgEmailList}
									setEmailList={setOrgEmailList}
									emailText={"Can't find the Organization you are looking for?"}
									validateExistingEmail={true}
									email={orgEmail}
									setEmail={setOrgEmail}
									isTypedEmailValid={isOrgEmailValid}
									setIsTypedEmailValid={setIsOrgEmailValid}
								/>
							}

							<hr className='card-configure__separation-line' />
							<div className='card-configure__body__text'>
								<div>Select the data elements that you would like your Solution </div>
								<div>Provider(s) to provide or consume on your behalf:</div>
							</div>

							{/* Dropdown - For sending and receiving the Data Elements */}
							<div className="card-configure__body__dropdown">
								<span className="card-configure__body__dropdown__title">
									Data Element(s) to provide on your behalf
								</span>
								<div className="card-configure__body__dropdown__option">
									<InputDropdown
										name={'dataElementContribute'}
										placeholder={"Select Data Element(s)"}
										dropdownOption={dataElementContributeItems}
										dropdownSelectedOption={sendDataElement}
										onSelectDropdownItem={setSendDataElement}
										value={dropdownSearch.dataElementContribute}
										multipleSelection
										onChange={handleDropdownSearch}
										fullWidth
										isLoading={dataElementLoading}
									/>
								</div>
							</div>
							<div className="card-configure__body__dropdown">
								<span className="card-configure__body__dropdown__title">
									Data Element(s) to consume on your behalf
								</span>
								<div className="card-configure__body__dropdown__option">
									<InputDropdown
										name={'dataElementConsume'}
										placeholder={"Select Data Element(s)"}
										dropdownOption={dataElementConsumeItems}
										dropdownSelectedOption={consumeDataElement}
										onSelectDropdownItem={setConsumeDataElement}
										value={dropdownSearch.dataElementConsume}
										multipleSelection
										onChange={handleDropdownSearch}
										fullWidth
										isLoading={dataElementLoading}
									/>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								variant={ButtonVariant.STANDARD}
								type={ButtonType.GHOST}
								text="Cancel"
								data-testid="cancel-button"
								onClick={() => {
									hideInitiateAddRelationshipModal();
								}}
								id="my-service-provider-modal-cancel-button"
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<AddRelationBtn
								onClick={handleSubmit}
								text={"Add"}
								{...{
									selectOrgIds,
									consumeDataElement,
									sendDataElement,
									orgEmailList,
									orgEmail,
									isOrgEmailValid
								}}
								id="my-service-provider-modal-add-button"
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast toastList={toastList} />
		</>
	)
}

export default ServiceProviderTablePage

ServiceProviderTablePage.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	data: PropTypes.arrayOf(PropTypes.object).isRequired,
	headers: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			render: PropTypes.func,
			sortable: PropTypes.bool
		})
	).isRequired,
	emptyMessage: PropTypes.string.isRequired,
	refreshData: PropTypes.bool.isRequired,
	setRefreshData: PropTypes.func.isRequired,
	customGroupHeaderRender: PropTypes.func,
	serviceProvidersItems: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired
		})
	).isRequired,
	dataElementContributeItems: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired
		})
	).isRequired,
	dataElementConsumeItems: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired
		})
	).isRequired,
	serviceProviderLoading: PropTypes.bool.isRequired,
	dataElementLoading: PropTypes.bool.isRequired,
	orgDataLoading: PropTypes.bool.isRequired
};

RenderGroupByTrigger.propTypes = {
	groupByDropdownOptions: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired
		})
	).isRequired
};
